// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promotion-scope-and-sequence .scope-and-sequence-button{width:fit-content;margin:auto;margin-bottom:15px}`, "",{"version":3,"sources":["webpack://./assets/src/scripts/components/product-promotion/scope-and-sequence-promotion-panel.vue"],"names":[],"mappings":"AAEC,yDACC,iBAAA,CACA,WAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
